import React from 'react';

const About = () => {
  return (
    <div
      name='about'
      className='w-full bg-gradient-to-b from-gray-800 to-black text-white'
    >
      <div className='max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full'>
        <div className='pt-4'>
          <p className='text-4xl font-bold inline border-b-4'>About</p>
        </div>

        <p className='text-xl mt-20'>
          I’m a Full-Stack Developer with experience building scalable web
          applications, SaaS platforms, AI-powered systems, and internal
          business tools for clients and companies across the USA, Europe, and
          Africa.
        </p>

        <br />

        <p className='text-xl'>
          My expertise spans frontend and backend development using technologies
          such as React, Next.js, Node.js, TypeScript, PostgreSQL, Prisma, and
          modern cloud-based tools. I’ve worked on projects ranging from
          eCommerce platforms and AI-integrated applications to HR systems,
          admin dashboards, and workflow automation tools.
        </p>

        <br />

        <p className='text-xl'>
          In addition to software engineering, I’ve also worked on AI evaluation
          and quality analysis projects through Turing, focusing on
          fact-checking, response evaluation, and AI output assessment.
        </p>

        <br />

        <p className='text-xl'>
          I enjoy building clean, scalable systems that solve real business
          problems while delivering great user experiences. I’m continuously
          learning and exploring new technologies in AI, backend architecture,
          automation, and modern web development.
        </p>
      </div>
    </div>
  );
};

export default About;
